import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useContext } from "react";
import SessionContext from "./session/SessionContext";

const useStyles = makeStyles((theme) => ({
  title: {
    width: "100%",
    height: "auto",
    padding: "0 7.5%",
    margin: "1% 0.5%",
    [theme.breakpoints.down("769")]: {
      width: "90%",
    },
  },
  subtitleLeft: {
    borderLeft: "7px solid #F5B750",
    fontSize: 26,
    color: "#344450",
    fontWeight: "bold",
    padding: "2% 3%",
    margin: "1% 0",
    [theme.breakpoints.down("1100")]: {
      borderLeft: "5px solid #F5B750",
      fontSize: 22,
    },
    [theme.breakpoints.down("769")]: {
      borderLeft: "4px solid #F5B750",
      fontSize: 18,
    },
  },
  subtitleRight: {
    borderRight: "7px solid #F5B750",
    fontSize: 26,
    color: "#344450",
    fontWeight: "bold",
    padding: "2% 3%",
    margin: "1% 0",
    [theme.breakpoints.down("1100")]: {
      borderRight: "5px solid #F5B750",
      fontSize: 22,
    },
    [theme.breakpoints.down("769")]: {
      borderRight: "4px solid #F5B750",
      fontSize: 18,
    },
  },
}));

export default function Title({ text }) {
  const classes = useStyles();
  let {
    session: { lang },
  } = useContext(SessionContext);
  let isAr = lang === "ar";
  return (
    <Box className={classes.title}>
      <Box className={isAr ? classes.subtitleRight : classes.subtitleLeft}>
        {text}
      </Box>
    </Box>
  );
}
